// no flow: util file, don't worry about type checking for now

import _str from 'app/common/underscore-string';

const MAX_MESSAGE_LENGTH = 500;

// split first and remaining lines of an error and do some magic
// follow same logic as useful.error_tools.construct_full_error_message()
export const parseErrorString = (errorMessage = '', explanation = null) => {
  // match to find message and details
  const errorMessageLines = errorMessage.trim().match(/.+[\n\r]*/g) || [];

  let message = (errorMessageLines[0] || '').trim();
  let details;
  if (message.length > MAX_MESSAGE_LENGTH) {
    details = errorMessage;
    message = _str.truncate(message, MAX_MESSAGE_LENGTH, '...');
  } else {
    details = errorMessageLines.slice(1).join('');
  }

  details = details
    .replace(/\r/g, '') // drop windows-style linebreaks
    .replace(/^[ \t]+$/gm, '') // drop empty lines
    .replace(/[\n]{2,}/g, '\n\n') // limit to 2 linebreaks
    .replace(/[ \t]+$/gm, '') // drop whitespace at end of lines or full lines of
    .replace(/^\n+|( *\n+)$/, ''); // get rid of linebreaks at start and end

  if (message === details) {
    details = '';
  }

  // append optional explanation to the first error message (first line)
  if (explanation) {
    if (message) {
      if (message[message.length - 1] !== '.') {
        message += '.';
      }
      message += ' ' + explanation;
    } else {
      message = explanation;
    }
  }

  return {
    message,
    details,
  };
};

export const isUpgradeRequired = errors =>
  errors && errors.length === 1 && errors[0].status === 426;

export const DATA_FLOW_PROTECTION_ERROR_NAME = 'data flow protection';

export const SECONDARY_AUTH_MISSING_ERROR = 'secondary_auth_missing';
export const SECONDARY_AUTH_FAILED_ERROR = 'secondary_auth_failed';
export const DATA_FLOW_NOT_ALLOWED_ERROR = 'data_flow_not_allowed';

export const isDataFlowProtectionRequired = errors => {
  if (!Array.isArray(errors) || errors.length < 1) {
    return false;
  }
  const lastErrorJson = (errors[errors.length - 1] || {}).json || {};
  if (!Array.isArray(lastErrorJson.checks)) {
    return false;
  }
  return lastErrorJson.checks.find(
    check => check.name === DATA_FLOW_PROTECTION_ERROR_NAME
  );
};
